import { AppState } from 'stores/index'
import { MunicipalityDetail } from 'components/municipalityDetail/component'
import { connect } from 'react-redux'
import { branch, renderNothing } from 'recompose'

export { MunicipalityDetail } from './component'

const mapStateToProps = ({
  activeMunicipality,
  valuesByMunicipality,
  categorySelection
}: AppState) => {
  let currentMunicipality = valuesByMunicipality.get(
    activeMunicipality.toString()
  )
  return {
    ...currentMunicipality,
    ...categorySelection,
    activeMunicipality,
    numberOfMunicipalities: valuesByMunicipality.size
  }
}

const hideIfWrongActiveMunicipality = branch(
  (props: { activeMunicipality: number }) => props.activeMunicipality <= 0,
  renderNothing
)

export default connect(
  mapStateToProps,
  undefined
)(hideIfWrongActiveMunicipality(MunicipalityDetail))
